/**
 *    SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import clientJson from '../../../package.json';
import FabricVersion from '../../FabricVersion';

const styles = () => ({
	root: {
		position: 'fixed',
		left: 0,
		right: 0,
		bottom: 0,
		zIndex: 1000
	},
	footerTop: {
		backgroundColor: '#4A90E2',
		color: '#ffffff',
		textAlign: 'center',
		padding: '15px 20px',
		fontSize: '14px'
	},
	footerBottom: {
		backgroundColor: '#e8e8e8',
		color: '#333333',
		textAlign: 'center',
		padding: '8px 20px',
		fontSize: '12px'
	}
});

const FooterView = ({ classes }) => (
	<div className={classes.root}>
		<div className={classes.footerTop}>
			© Copyright Digital Global Kingdom
		</div>
	</div>
);

export default withStyles(styles)(FooterView);
